import { render } from "./CommonSpinner.vue?vue&type=template&id=66c2674b&scoped=true&ts=true"
import script from "./CommonSpinner.vue?vue&type=script&lang=ts"
export * from "./CommonSpinner.vue?vue&type=script&lang=ts"

import "./CommonSpinner.vue?vue&type=style&index=0&id=66c2674b&lang=stylus&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66c2674b"]])

export default __exports__